// packages/front/src/portfolio/modals/fetch-exchange-rate-modal.tsx

import { useState, type FC } from "react";
import { Button, Modal } from "../../_common";
import { useRefreshExchangeRates } from "../portfolio.hooks";

export interface FetchExchangeRateModalProps {
  open: boolean;
  onClose: () => void;
}

const inputClass =
  "h-9 rounded-md border border-input bg-background px-3 py-1 text-sm";
const labelClass = "text-sm font-medium";

export const FetchExchangeRateModal: FC<FetchExchangeRateModalProps> = ({
  open,
  onClose,
}) => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [message, setMessage] = useState<string | null>(null);
  const refreshRates = useRefreshExchangeRates();

  const handleRefreshRates = async () => {
    setMessage(null);
    try {
      const res = await refreshRates.mutateAsync({ date });
      setMessage(`Fetched ${res.refreshed} rates for ${date}`);
    } catch {
      setMessage("Fetch failed");
    }
  };

  const handleClose = () => {
    setMessage(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Fetch Exchange Rates by Date">
      <p className="text-xs text-muted-foreground">
        Fetches historical exchange rates from FMP for the selected date.
        If the date is today, fetches current (spot) rates.
      </p>
      <div className="flex flex-col gap-3">
        <label className={labelClass}>Date</label>
        <input
          className={inputClass}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        {message && (
          <div className="text-sm text-muted-foreground">{message}</div>
        )}

        <div className="mt-2 flex gap-2">
          <Button type="button" variant="outline" onClick={handleClose}>
            Close
          </Button>
          <Button type="button" disabled={refreshRates.isPending} onClick={handleRefreshRates}>
            {refreshRates.isPending ? "Fetching..." : "Fetch from FMP"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
